import { createContext } from 'react';

import { RelatorioAprovacaoConfig } from 'helper/Relatorios/Aprovacao/config';

/**
 * Contexto estático: só carrega a config do informe (sem estado). Fornecido por
 * `RelatorioSecoesView`; os componentes de aprovação seguem chamando
 * `useRelatorioAprovacao()` por instância (igual ao DESSEM original).
 */
const RelatorioAprovacaoConfigContext = createContext<RelatorioAprovacaoConfig | undefined>(
  undefined,
);

export default RelatorioAprovacaoConfigContext;
